// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog .search-chat[data-v-4ea8240c] {
  margin-bottom: 15px;
}
.dialog[data-v-4ea8240c] .body {
  height: calc(var(--vh) * 65);
  display: flex;
  flex-direction: column;
}
.select-chat[data-v-4ea8240c] {
  width: 100%;
  overflow-y: auto;
  padding: 0px;
  display: flex;
  flex-direction: column;
}
.select-chat .chats-list[data-v-4ea8240c] {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
  flex: 1;
}
.select-chat .chats-list .chat-item-wrapper[data-v-4ea8240c] {
  display: flex;
  height: 70px;
  min-height: 70px;
  align-items: center;
  cursor: pointer;
  padding: 0px 10px;
}
.select-chat .chats-list .chat-item-wrapper[data-v-4ea8240c]:hover {
  background-color: var(--list-item-bghover);
}
.select-chat .chats-list .chat-item-wrapper > *[data-v-4ea8240c]:not(:first-child) {
  margin: auto 0 auto 12px;
}
.select-chat .chats-list .chat-item-wrapper.selected[data-v-4ea8240c] {
  background-color: var(--list-item-activebgcolor);
}
.select-chat .chats-list .chat-item-wrapper .fio-block[data-v-4ea8240c] {
  font-size: 16px;
  overflow: hidden;
}
.select-chat .chats-list .chat-item-wrapper .fio-block .name[data-v-4ea8240c] {
  display: flex;
  height: 20px;
}
.select-chat .chats-list .chat-item-wrapper .fio-block span[data-v-4ea8240c] {
  display: block;
  width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.select-chat .chats-list .chat-item-wrapper .fio-block i[data-v-4ea8240c] {
  padding-right: 10px;
  margin: auto;
}
.select-chat .chats-list .chat-item-wrapper:last-child .hor-line[data-v-4ea8240c] {
  display: none;
}
.select-chat .chats-list .hor-line[data-v-4ea8240c] {
  height: 1px;
  background: var(--hor-line-color);
  width: calc(100% - 68px);
  margin-left: 68px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/SelectChat.vue"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,wBAAwB;EACxB,iBAAiB;AACnB","sourcesContent":[".dialog .search-chat[data-v-4ea8240c] {\n  margin-bottom: 15px;\n}\n.dialog[data-v-4ea8240c] .body {\n  height: calc(var(--vh) * 65);\n  display: flex;\n  flex-direction: column;\n}\n.select-chat[data-v-4ea8240c] {\n  width: 100%;\n  overflow-y: auto;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n}\n.select-chat .chats-list[data-v-4ea8240c] {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  position: relative;\n  flex: 1;\n}\n.select-chat .chats-list .chat-item-wrapper[data-v-4ea8240c] {\n  display: flex;\n  height: 70px;\n  min-height: 70px;\n  align-items: center;\n  cursor: pointer;\n  padding: 0px 10px;\n}\n.select-chat .chats-list .chat-item-wrapper[data-v-4ea8240c]:hover {\n  background-color: var(--list-item-bghover);\n}\n.select-chat .chats-list .chat-item-wrapper > *[data-v-4ea8240c]:not(:first-child) {\n  margin: auto 0 auto 12px;\n}\n.select-chat .chats-list .chat-item-wrapper.selected[data-v-4ea8240c] {\n  background-color: var(--list-item-activebgcolor);\n}\n.select-chat .chats-list .chat-item-wrapper .fio-block[data-v-4ea8240c] {\n  font-size: 16px;\n  overflow: hidden;\n}\n.select-chat .chats-list .chat-item-wrapper .fio-block .name[data-v-4ea8240c] {\n  display: flex;\n  height: 20px;\n}\n.select-chat .chats-list .chat-item-wrapper .fio-block span[data-v-4ea8240c] {\n  display: block;\n  width: 250px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.select-chat .chats-list .chat-item-wrapper .fio-block i[data-v-4ea8240c] {\n  padding-right: 10px;\n  margin: auto;\n}\n.select-chat .chats-list .chat-item-wrapper:last-child .hor-line[data-v-4ea8240c] {\n  display: none;\n}\n.select-chat .chats-list .hor-line[data-v-4ea8240c] {\n  height: 1px;\n  background: var(--hor-line-color);\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
